import { getGroupedAndSortedParametrs } from './index';
import { goalkeepersModalParams } from '../config/parametrs/goalkeepersModalParams';

export const GK_POSITION_ID = 10;

export const isGoalkeeper = (player) => {
  if (!player) return false;
  const positions = player?.position?.data ?? player?.position ?? player?.positions;
  if (Array.isArray(positions)) {
    return positions.some((p) => {
      if (typeof p === 'string') return p === 'GK';
      return p?.id === GK_POSITION_ID || p?.name === 'GK' || p?.abbreviation === 'GK';
    });
  }
  return false;
};

export const buildFieldPlayerParamGroups = (parameters, withoutGroup = false) =>
  getGroupedAndSortedParametrs(parameters, withoutGroup);

export const buildGoalkeeperParamGroups = (parameters) => {
  const gkParamIds = goalkeepersModalParams.map((item) => item.paramId);
  const gkOnly = (parameters || []).filter((item) => gkParamIds.includes(item.id));
  return getGroupedAndSortedParametrs(gkOnly);
};

export const buildParamGroupsForPlayer = (parameters, player) => {
  if (isGoalkeeper(player)) {
    return buildGoalkeeperParamGroups(parameters);
  }
  return buildFieldPlayerParamGroups(parameters);
};

export const flattenParamIds = (groupedParams) => {
  if (!Array.isArray(groupedParams)) return [];
  return groupedParams.flatMap(([, items]) => items.map((item) => item.id));
};
